var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "mic_off"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_364_1472",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_364_1472)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mic_off_2",
    d: "M11.8331 9.96659L10.8664 8.99992C11.022 8.74436 11.1387 8.4777 11.2164 8.19992C11.2942 7.92214 11.3331 7.63325 11.3331 7.33325H12.6664C12.6664 7.82214 12.5942 8.28603 12.4498 8.72492C12.3053 9.16381 12.0998 9.5777 11.8331 9.96659ZM9.86644 7.96659L5.99977 4.09992V3.33325C5.99977 2.7777 6.19422 2.30547 6.58311 1.91659C6.97199 1.5277 7.44422 1.33325 7.99977 1.33325C8.55533 1.33325 9.02755 1.5277 9.41644 1.91659C9.80533 2.30547 9.99977 2.7777 9.99977 3.33325V7.33325C9.99977 7.45547 9.98588 7.56659 9.95811 7.66659C9.93033 7.76659 9.89977 7.86659 9.86644 7.96659ZM7.33311 13.9999V11.9333C6.17755 11.7777 5.22199 11.2638 4.46644 10.3916C3.71088 9.51936 3.33311 8.49992 3.33311 7.33325H4.66644C4.66644 8.25547 4.99144 9.04159 5.64144 9.69159C6.29144 10.3416 7.07755 10.6666 7.99977 10.6666C8.37755 10.6666 8.73588 10.6083 9.07477 10.4916C9.41366 10.3749 9.722 10.211 9.99977 9.99992L10.9498 10.9499C10.6276 11.2055 10.2748 11.4194 9.89144 11.5916C9.50811 11.7638 9.09977 11.8777 8.66644 11.9333V13.9999H7.33311ZM13.1998 15.0666L0.933105 2.79992L1.86644 1.86659L14.1331 14.1333L13.1998 15.0666Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicOff);
export default __webpack_public_path__ + "static/media/mic_off.198653672c07db1c66095865efd84f88.svg";
export { ForwardRef as ReactComponent };